import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Modal,
  Nav,
  OverlayTrigger,
  Row,
  Tab,
  Tooltip,
} from "react-bootstrap";
import { FaArrowRight, FaUsers } from "react-icons/fa";
import { intialReleaseNotes, releaseNotesLabel, releaseNotesRules } from "./Constant";
import { FiEdit, FiPlusCircle } from "react-icons/fi";
import FormInput from "app/Components/_form/FormInput/FormInput";
import RichTextarea from "app/Components/RichTextarea/RichTextarea";
import InputError from "app/Components/_form/InputError/InputError";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import { useForm } from "app/_helpers/hooks";
import { Validation } from "app/_helpers/validation/Validation";
import toastr from "toastr";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import {
  addReleaseNotes,
  getAllReleaseNotes,
  updateReleaseNotes,
} from "app/_services/ehs/ehsServices";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { SetPermission, isPermissions } from "app/Components/SetPermission/Permissions";
import FormCheckbox from "app/Components/_form/FormCheckbox/FormCheckbox";

const ReleaseNotes = () => {
  const [activeKey, setActiveKey] = useState();
  const [showManageModal, setShowManageModal] = useState(false);
  const [selectedRelease, onChange, setSelectedRelease] = useForm({
    ...intialReleaseNotes,
  });
  const [error, setError] = useState({});
  const [releaseNotesData, setReleaseNotesData] = useState([]);

  const fetchData = async () => {
    const response = await getAllReleaseNotes();
    if (!response?.status) return;
    setReleaseNotesData(
      response?.data?.filter((obj) => isPermissions("superAdmin") || obj?.status) || []
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  const updateFunc = (row) => {
    setSelectedRelease(row);
    setShowManageModal(true);
    setError({});
  };

  const onSubmit = async () => {
    const errorObj = Validation(selectedRelease, releaseNotesRules);
    setError(errorObj);
    if (Object.values(errorObj).filter((d) => d !== "").length) return;

    let response;
    let selectedReleaseObj = {
      ...selectedRelease,
      status: selectedRelease?.status ? 1 : 0,
    };
    if (selectedRelease?.id) {
      response = await updateReleaseNotes(selectedRelease?.id, selectedReleaseObj);
    } else {
      response = await addReleaseNotes(selectedReleaseObj);
    }
    if (!response?.status) return toastr.error(response?.message);
    toastr.success(response?.message);
    setShowManageModal(false);
    setSelectedRelease({ ...intialReleaseNotes });
    fetchData();
  };

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Release Notes", path: "#" },
          { name: "View ", path: "#" },
        ]}
      />
      <SetPermission
        permission={["superAdmin"]}
        data={
          <CustomTooltip tooltip={"Add Release Notes"}>
            <span
              className="icons btn-icon font-20 text-cyanBlue"
              onClick={() => {
                setShowManageModal(true);
                setError({});
                setSelectedRelease({ ...intialReleaseNotes });
              }}
            >
              <FiPlusCircle />
            </span>
          </CustomTooltip>
        }
      />

      <Tab.Container defaultActiveKey={"0"} activeKey={activeKey} onSelect={setActiveKey}>
        <Row>
          <Col xs={12} sm={6} md={3} lg={3} className="px-0 my-1">
            <Nav
              variant="pills"
              className="flex-column p-1 border rounded mx-1"
              style={{ minHeight: "100%" }}
            >
              {releaseNotesData.length > 0 ? (
                <>
                  {releaseNotesData.map((obj, idx) => (
                    <Nav.Item key={idx}>
                      <Nav.Link eventKey={idx}>
                        <TabTitle
                          title={obj?.releaseDate ? DDMMYYYYFormat(obj?.releaseDate) : ""}
                          active={activeKey === idx}
                          status={isPermissions("superAdmin") && obj?.status}
                        />
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </>
              ) : (
                <>
                  <h5 className="text-center">No Data exists</h5>
                </>
              )}
            </Nav>
          </Col>
          <Col xs={12} sm={6} md={9} lg={9} className="px-0 my-1">
            <Tab.Content className="p-0 border rounded" style={{ minHeight: 350 }}>
              {releaseNotesData.length > 0 ? (
                <>
                  {releaseNotesData.map((obj, idx) => (
                    <Tab.Pane eventKey={idx} key={idx}>
                      <div className="titleHD">
                        <h4 className="text-capitalize mb-1">{`${releaseNotesLabel.version} : ${obj?.version}`}</h4>
                        <SetPermission
                          permission={["superAdmin"]}
                          data={
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="tooltip-top">Update</Tooltip>}
                            >
                              <span
                                className="icons text-cyanBlue"
                                onClick={() => {
                                  updateFunc(obj);
                                }}
                              >
                                <FiEdit size={20} />
                              </span>
                            </OverlayTrigger>
                          }
                        />
                      </div>
                      <Row className="mb-3 p-3">
                        <Col md={12} className="drilingView-bx">
                          <h5>{releaseNotesLabel.description}</h5>
                          <div className="emailContent">
                            <p
                              dangerouslySetInnerHTML={{
                                __html: obj?.description,
                              }}
                            ></p>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Pane>
                  ))}
                </>
              ) : (
                <>
                  <h5 className="text-center">No Data exists</h5>
                </>
              )}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
      <Modal show={showManageModal} size="lg" backdrop="static">
        <div className="card" style={{ overflow: "visible" }}>
          <div className="card-body">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">{`${
                !selectedRelease?.id ? "Add" : "Update"
              } Release Notes`}</h3>
            </div>
            <Row className="mb-3">
              <Col lg={12}>
                <label>{releaseNotesLabel.releaseDate}</label>
                <DatePicker
                  name="releaseDate"
                  value={selectedRelease.releaseDate}
                  onChange={(moment, name) =>
                    typeof moment !== "string" &&
                    onChange({ target: { name, value: moment.format("YYYY-MM-DD") } })
                  }
                  // isValidDate={disableFutureDate}
                />
                <InputError error={error?.releaseDate} />
              </Col>

              <Col lg={12}>
                <FormInput
                  label={releaseNotesLabel.version}
                  name="version"
                  value={selectedRelease?.version}
                  onChange={onChange}
                  error={error?.version}
                />
              </Col>

              <Col lg={12}>
                <label className="text-capitalize mb-1">
                  {releaseNotesLabel.description}
                </label>
                <RichTextarea
                  name="description"
                  onChange={onChange}
                  value={selectedRelease?.description || ""}
                />
                <InputError error={error?.description} />
              </Col>

              <Col lg={12} className="mt-2">
                <FormCheckbox
                  type="checkbox"
                  name="status"
                  checked={selectedRelease?.status}
                  onChange={onChange}
                  label={releaseNotesLabel.status}
                />
              </Col>
            </Row>
            <div className="mt-2 text-center">
              <Button
                onClick={() => {
                  setShowManageModal(false);
                  setSelectedRelease({ ...intialReleaseNotes });
                }}
                className="btn btn-secondary mr-2"
              >
                Close
              </Button>
              <Button
                onClick={onSubmit}
                type="submit"
                variant="primary"
                className="m-1 text-capitalize"
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ReleaseNotes;

export const TabTitle = ({ title, active, status }) => {
  return (
    <div className="d-flex justify-content-between pointer">
      <div>
        {title} {status ? <FaUsers size={20} /> : ""}
      </div>
      <div className={active ? "tabActive" : "mr-tab"}>
        <FaArrowRight />
      </div>
    </div>
  );
};
